<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <!-- <p>ValorDefinido:{{this.valorDefinido}}</p>
      <p>hereda:{{this.hereda}}</p>      
      <p>id del modelo:{{this.idDelModelo}}</p> -->
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)" v-bind:disabled="desHabilitaEdicion">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un puesto</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todos.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los juzgados</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todas.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todas.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} las áreas</option>
        <!-- <option v-for="Puesto in Puestos" :key="Puesto.PuestoId" :value="Puesto.PuestoId">{{Puesto.Nombre}}</option> -->
        <option v-for="(puesto,index) in Puestos" :value="puesto.PuestoId" :key="index">{{puesto.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'  

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        Puestos: [],
        idDelModelo: null,
        desHabilitaEdicion:true
      }
    },
    props: {
      prefijo: Number,
      filtraEquitas :{
        default:false
      },
      tipo: {
        Id: Number,
        Nombre: String
      },
      local: null,
      idDelInput: String,
      valorDefinido: Number,
      parametros: {AreaId:null,DepartamentoId:null},
      hereda:{
        type:Number,
        default:null
      }
    },
    created() {      
      this.desHabilitaEdicion = this.hereda != null && this.hereda == -1
      this.cargaCatalogoDePuestos(this.parametros)
    }, 
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer045Puesto", parametros);
    },
    methods: {
      cargaCatalogoDePuestos: function(parametrosDeConsulta) {
        let peticion = {
          PuestoId: this.PuestoId,
          TipoPuestoId: null,
          AreaId: parametrosDeConsulta.AreaId,
          TipoDepartamentoId: parametrosDeConsulta.DepartamentoId,
          conInactivos: false,
          conTipoPuesto: false,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        axios.post(api.conexion + api.PJ.catalogos.C045Puestos, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Puestos = respuesta.data.Puestos;
              // return respuesta.data.Puestos;              
              


              if(this.parametros.elementosAOmitir != undefined){
                      this.Puestos = this.Puestos.filter(element => {                   
                      if(!this.parametros.elementosAOmitir.includes(element.PuestoId))
                      return element;
                      });
                      }

                      if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                      this.Puestos = this.Puestos.filter(element => {                  
                      if(this.parametros.elementosAConservar.includes(element.PuestoId))
                      return element;
                      });
                      }



            }
          }).catch(e => {
           console.log("No Hay Respuesta del Servidor" + e);
         });

      },
      cambiarDatos(evento) { 
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer045Puesto", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }      
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/045Puestos.vue